import { useState } from 'react';
import { useAppStore } from '../stores';
import { HouseholdAggregate, householdAsSeenBy, summarizeHousehold } from '../domain';

export const useHouseholdCard = (aggregate: HouseholdAggregate) => {
  const { household } = aggregate;
  const { user } = useAppStore(state => state.auth);
  const { deleteHousehold } = useAppStore(state => state.chores);
  const [isInviteModalOpen, setIsInviteModalOpen] = useState(false);
  const [isMembersDialogOpen, setIsMembersDialogOpen] = useState(false);
  const [isDeleteConfirmOpen, setIsDeleteConfirmOpen] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);

  // Logic: UI-ready helpers
  const isOwner = user?.uid === household.owner_id;

  const since = new Date(household.created_at).toLocaleDateString(undefined, {
    year: 'numeric',
    month: 'long',
  });

  // The display names run parallel to the ids.
  const members = (household.member_ids ?? []).map((id, i) => ({
    id,
    name: household.member_display_names?.[i] || 'Member',
  }));

  // A child counts only the chores they see.
  const { choreCount, overdueCount } = summarizeHousehold(householdAsSeenBy(aggregate, user?.uid));

  // Actions
  const confirmRemove = async () => {
    setIsDeleting(true);
    try {
      await deleteHousehold(household.id);
      setIsDeleteConfirmOpen(false);
    } finally {
      setIsDeleting(false);
    }
  };

  return {
    isOwner,
    since,
    members,
    choreCount,
    overdueCount,
    isDeleteConfirmOpen,
    isDeleting,
    openDeleteConfirm: () => setIsDeleteConfirmOpen(true),
    closeDeleteConfirm: () => setIsDeleteConfirmOpen(false),
    confirmRemove,
    isInviteModalOpen,
    openInviteModal: () => setIsInviteModalOpen(true),
    closeInviteModal: () => setIsInviteModalOpen(false),
    isMembersDialogOpen,
    openMembersDialog: () => setIsMembersDialogOpen(true),
    closeMembersDialog: () => setIsMembersDialogOpen(false),
  };
};